import React, { Component } from 'react';
import { connect } from 'react-redux';
import URC from 'ui-react-common';
import PIIRetryForm from './components/pii-retry-form/PIIRetryForm';
import { parseQueryString } from '../../components/routing';

const { Page } = URC.ui.containers;
const { Type } = URC.ui.components;

export class PIIRetryPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = Object.assign(
            {},
            {
                queryParams: parseQueryString(
                    this.props.location.search,
                    window.localStorage
                ),
            }
        );
    }

    render() {
        return (
            <Page id="piiRetry" heading="We Had Trouble Verifying Your Information">
                <Type.BodyTwo>
          For security reasons, please carefully review the information below
          and re-enter your Social Security Number. Everything must be accurate
          for us to present you with any loan options.
                </Type.BodyTwo>
                <PIIRetryForm queryParams={this.state.queryParams} />
            </Page>
        );
    }
}

PIIRetryPageComponent.propTypes = {};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PIIRetryPageComponent);
